module.exports = __webpack_public_path__ + "static/maruya-cassava-3b13cd26440694f9cf2ea7ff8092ffb8.jpg";